// @noflow
import { all, call, put, select } from 'redux-saga/effects';

import { getIsLoggedIn } from '~/core/state/application/selectors';
import { logOut } from '~/core/state/application/actions';
import toResult from './toResult';

const statusEffectsMap = {
    401: () => [
        function*() {
            const isLoggedIn = yield select(getIsLoggedIn);
            if (isLoggedIn) {
                yield put(logOut());
            }
        }
    ]
};

export default function handleApi(fn) {
    return toResult(function* handleApiGenerator(...params) {
        const result = yield call(fn, ...params);
        if (!result) {
            return;
        }

        const effects = statusEffectsMap[result.status];

        if (effects) {
            yield all(
                effects(result, ...params).map(function*(effect) {
                    yield effect();
                })
            );
        }

        let body;
        body = yield call(() => result.text());
        body = body.length ? JSON.parse(body) : {};

        if (result.status >= 200 && result.status <= 299) {
            return body;
        } else {
            const message = typeof result === 'string' && result;
            const error = new Error(message);
            error.status = body && (body.error || body.errors);
            error.code = result.status;
            throw error;
        }
    });
}



// WEBPACK FOOTER //
// ./src/core/state/handle-api.js